import message from "../../../../assets/img/contact-message.svg";
import id from "../../../../assets/img/generalView/id.svg";
import name from "../../../../assets/img/generalView/name.svg";
import phone from "../../../../assets/img/generalView/phone.svg";
import address from "../../../../assets/img/generalView/address.svg";
import companySize from "../../../../assets/img/generalView/companySize.svg";
import details from "../../../../assets/img/generalView/details.svg";
import calendar from "../../../../assets/img/generalView/calendar.svg";
import status from "../../../../assets/img/generalView/status.svg";
import arrow from "../../../../assets/img/generalView/downArrow.svg";

import React, { Component } from "react";

import * as qs from "query-string";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import debounce from "lodash.debounce";
import { ApiRoutes } from "../../../../config";
import { ApiHelper } from "../../../../helpers";
import PHLContext from "../../../../PHLContext";
import filterarrowIcon from "../../../../assets/img/filter-arrow.svg";
import "../../../containers/enquiries/general/general.css";
import { Breadcrumbs } from "../../../components/partial/Breadcrumbs";
import {
  ViewDetailsShimmer,
  ViewDetailsSecondShimmer,
} from "../../loader/Resusable/viewGeneralDetail";

let lat, long;

class ViewDetail extends Component {
  static contextType = PHLContext;
  constructor(props) {
    super(props);
    this.state = {
      generalDetail: {},
      requestId: "",
      IndividualGeneralDetail: {},
      isLoading: false,
      totalRecords: 0,
      currentPage: 1,
      limit: 10,
      activeId: "",
      sortBy: "createdAt",
      order: "desc",
      search: "",
      newRecord: false,
      isFilterApplied: false,
      showAddForm: false,
      catOption: [],
      userDetail: "",
      isViewModal: false,
      isUpdateTicket: false,
      selectedStatus: "",
      statusList: [
        "Completed",
        "Acknowledged",
        "Canceled",
        "In Process",
        "Reopened",
      ],
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    const pathNamesDetails = this.props.location.pathname.split("/");
    this.setState(
      {
        userDetail: this.props.location.pathname.split("/")[2], //[3],
        requestId:
          this.props.location.pathname.split("/")[pathNamesDetails?.length - 1],
      },
      () => this.handleQueryParams()
    );

    this.handleQueryParams();
  };
  handleQueryParams = async () => {
    const {
      location: { search },
    } = this.props;
    const query = qs.parse(search);
    if (query && query.sort === "location") {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      lat = position.coords.latitude;
      long = position.coords.longitude;
    }
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        sortBy: query.sort || "createdAt",
        order: query.order
          ? query.order
          : // : query.sort === 'scan_id' || query.sort === 'created_at'
            // ? 'desc'
            "desc",
        search: query.search || "",
        isFilterApplied: query.sort || query.search ? true : false,
      },
      () => this.fetchGeneralRecords()
    );
  };

  componentDidUpdate = ({ location: { search: prevSearch } }, prevState) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
    const splitValue = this.props.location.pathname.split("/")[2]; //[3];
    if (prevState.userDetail !== splitValue) {
      this.setState({
        userDetail: splitValue,
      });
      setTimeout(() => {
        this.handleQueryParams();
      }, 500);
    }
  };

  fetchGeneralRecords = async () => {
    const { currentPage, sortBy, search, limit, newRecord, order, userDetail } =
      this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      order,
    };
    // Function to check if a value is empty (undefined, null, or empty string)
    const isEmpty = (value) =>
      value === undefined || value === null || value === "";

    const filteredData = Object.entries(data).reduce((acc, [key, value]) => {
      if (!isEmpty(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    this.setState({
      isLoading: true,
    });
    if (search && this.state.isLoading) {
      new ApiHelper().cancelRequest("cancel");
    }

    const response = await new ApiHelper().NewFetchFromServer(
      ApiRoutes.GET_GENERAL_ENQUIRIES_NEW.service,
      ApiRoutes.GET_GENERAL_ENQUIRIES_NEW.url,
      ApiRoutes.GET_GENERAL_ENQUIRIES_NEW.method,
      ApiRoutes.GET_GENERAL_ENQUIRIES_NEW.authenticate,
      { enquiryId: this.state.requestId },
      undefined,
      undefined
    );

    if (response && response.isError) {
      toast.error(response.messages[0]);
      this.setState({
        isLoading: false,
      });
    } else {
      const datas = response?.data?.data;
      const formatedDate = this.DateFormatChange(datas?.updatedAt);
      this.setState({
        generalDetail: { ...datas, updatedAt: formatedDate },
        newRecord: false,
        totalRecords: datas?.length,
      });
      this.setState({
        isLoading: false,
      });
    }
  };

  DateFormatChange = (val) => {
    const originalDate = new Date(val);
    console.log(val, ":::::");

    // Format the date as MM/DD/YYYY
    const formattedDate = originalDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    return formattedDate;
  };

  setFilter = (sortBy, order) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sort = sortBy;
    }
    if (order) {
      params.order = order;
    }
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  onSearch = () => {
    const { search } = this.state;
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  componentWillUnmount = () => {
    this.emitSearch.cancel();
  };

  onEdit = (IndividualGeneralDetail) => {
    // this.fetchCategoryList();
    this.setState({
      IndividualGeneralDetail: IndividualGeneralDetail,
      showAddForm: true,
    });
  };

  handleUpdateTicket = async (status) => {
    this.setState({
      selectedStatus: status,
      isLoading: true,
    });
    const payload = {
      enquiryId: this.state.requestId,
      status: status,
    };

    const response = await new ApiHelper().NewFetchFromServer(
      ApiRoutes.CHANGE_STATUS_GENERAL_ENQUIRIES_NEW.service,
      ApiRoutes.CHANGE_STATUS_GENERAL_ENQUIRIES_NEW.url,
      ApiRoutes.CHANGE_STATUS_GENERAL_ENQUIRIES_NEW.method,
      ApiRoutes.CHANGE_STATUS_GENERAL_ENQUIRIES_NEW.authenticate,
      undefined,
      payload,
      undefined
    );
    if (response && response.isError) {
      this.setState({
        isLoading: false,
      });
      toast.error(response.messages[0]);
    } else {
      const datas = response?.data?.data;
      const formatedDate = this.DateFormatChange(datas?.updatedAt);

      this.setState({
        generalDetail: { ...datas, updatedAt: formatedDate },
        isLoading: false,
      });
      toast.success(response.data.message);
    }
  };

  handleTickets = (value) => {
    this.setState({
      isUpdateTicket: value,
    });
  };

  render() {
    const { generalDetail, isLoading, statusList } = this.state;

    const {
      props: {
        location: { pathname },
      },
    } = this;

    return (
      <>
        <div className="container-fluid fluid-pd-2">
          <h1 className="h3-head-mob d-md-none">Enquiries</h1>
          <Breadcrumbs pathname={pathname} />

          <div className="card card-pagination card-main">
            <div className="card-header py-7550 align-items-center justify-content-between">
              {isLoading ? (
                <ViewDetailsShimmer />
              ) : (
                <>
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#0A1F44",
                      }}
                    >
                      Request Details - {generalDetail?.name}
                    </span>
                    <div
                      className="contact-button"
                      onClick={() => {
                        if (generalDetail?.phone) {
                          window.open(`tel:${generalDetail?.phone}`);
                        } else if (generalDetail?.email) {
                          window.open(`mailto:${generalDetail?.email}`);
                        } else {
                          toast.info("There is no any contact details.");
                        }
                      }}
                    >
                      <span style={{ marginRight: "5px", marginBottom: "2px" }}>
                        <img src={message} alt="" className={"img-main"} />
                      </span>
                      <span>Contact</span>
                    </div>
                  </div>

                  <div className="container-user-details">
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={id}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div> Request ID</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.request_id
                            ? generalDetail?.request_id
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={name}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div>Requester Name</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.name ? generalDetail?.name : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={name}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div>Email ID</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.email ? generalDetail?.email : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={phone}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div>Phone Number</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.phone ? generalDetail?.phone : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={companySize}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div>Company Size</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.companySize
                            ? generalDetail?.companySize
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={address}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div>Company Address</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                            maxWidth: "220px",
                            wordBreak: "break-all",
                          }}
                        >
                          {generalDetail?.companyAddress}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className=""
                    style={{
                      width: "100%",
                      height: "auto",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        margin: "10px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            width: "14px",
                            marginRight: "11px",
                          }}
                        >
                          <img
                            src={details}
                            style={{ width: "100%", height: "100%" }}
                            alt="image"
                          />
                        </div>
                        <div>Details</div>
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#4A4A4A",
                          paddingLeft: "24px",
                        }}
                      >
                        {generalDetail?.details}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div
            className="card card-pagination card-main"
            style={{ marginTop: "24px" }}
          >
            {isLoading ? (
              <ViewDetailsSecondShimmer />
            ) : (
              <>
                <div className="card-header py-7550 align-items-center justify-content-between">
                  <div className="d-flex align-items-center justify-content-between">
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#0A1F44",
                      }}
                    >
                      Assignee Details
                    </span>
                    <div className="button-container">
                      <div
                        style={{
                          marginRight: "12px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "29px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "7px",
                          border: "1px #0F51A1 solid",
                          color: "#74798c",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        View Staff
                      </div>

                      <div
                        style={{
                          marginRight: "12px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "29px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "7px",
                          border: "1px #0F51A1 solid",
                          color: "#74798c",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        Un-Assign
                      </div>

                      <div
                        style={{
                          marginRight: "12px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "29px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "7px",
                          border: "1px #0F51A1 solid",
                          color: "#74798c",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                      >
                        Change Assignee
                        <div style={{ marginLeft: "6px" }}>
                          <img src={arrow} />
                        </div>
                      </div>

                      <Dropdown className="no-arrow dp-right">
                        <Dropdown.Toggle
                          variant="secondary"
                          id="dropdown-basic"
                          className={"filter-btn newArrowcz"}
                        >
                          {"Update Ticket"}{" "}
                          <span className="staff-value"></span>{" "}
                          {"showImage" ? (
                            <img src={filterarrowIcon} alt="" />
                          ) : (
                            ""
                          )}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="shadow dropdown-menu-right dropdown-staff">
                          {statusList?.map((status, index) => {
                            return (
                              <>
                                <Dropdown.Item
                                  as="div"
                                  key={index}
                                  onClick={() => {
                                    this.handleUpdateTicket(status);
                                  }}
                                >
                                  {status}
                                </Dropdown.Item>
                              </>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="container-user-details">
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px 0px 0px 0px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={companySize}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div> Assigned to</div>
                        </div>
                      </div>
                      <div
                        style={{
                          fontWeight: 600,
                          color: "#4A4A4A",
                          paddingLeft: "24px",
                        }}
                      >
                        {`${generalDetail?.assignStaffId?.first_name} ${generalDetail?.assignStaffId?.last_name}`}
                      </div>
                    </div>

                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={calendar}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div> Last Action On</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.updatedAt}
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="status-field">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            style={{
                              width: "14px",
                              marginRight: "11px",
                            }}
                          >
                            <img
                              src={status}
                              style={{ width: "100%", height: "100%" }}
                              alt="image"
                            />
                          </div>
                          <div> Request Status</div>
                        </div>
                        <div
                          style={{
                            fontWeight: 600,
                            color: "#4A4A4A",
                            paddingLeft: "24px",
                          }}
                        >
                          {generalDetail?.status}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default ViewDetail;
